import { format, startOfDay, endOfDay, parseISO } from 'date-fns';
import { toZonedTime, formatInTimeZone } from 'date-fns-tz';

const timeZone = 'Asia/Shanghai';
// const timeZone = 'Asia/Bangkok';

export const formatToTimeZone = (text: string | Date, formatString: string) => {
    const date = new Date(text);
    return formatInTimeZone(date, timeZone, formatString);
}

export const getCurrentDateInTimeZone = () => {
    return toZonedTime(new Date(), timeZone);
}

export const getStartOfDayInTimeZone = (date: Date = new Date()) => {
    // Format the date to get the date string in GMT+8
    const dateStrInTimeZone = formatInTimeZone(date, timeZone, 'yyyy-MM-dd');
    // Create ISO string with +08:00 offset for start of day
    const startOfDayStr = `${dateStrInTimeZone}T00:00:00.000+08:00`;
    // Parse this timezone-aware string
    return new Date(startOfDayStr);
}

export const getEndOfDayInTimeZone = (date: Date = new Date()) => {
    // Format the date to get the date string in GMT+8
    const dateStrInTimeZone = formatInTimeZone(date, timeZone, 'yyyy-MM-dd');
    // Create ISO string with +08:00 offset for end of day
    const endOfDayStr = `${dateStrInTimeZone}T23:59:59.999+08:00`;
    // Parse this timezone-aware string
    return new Date(endOfDayStr);
}